import type { FormRule } from 'antd';
import type { TTripValidatedFormFields } from './types';

export const trailerValidator = (truckSubType: string | undefined, hasTrailerPlate: boolean) => ({
  message: 'Trailer is required',
  validator(_: unknown, value: string) {
    if (hasTrailerPlate) return Promise.resolve();
    if (truckSubType === 'truck_head' && !value) {
      return Promise.reject(new Error('Trailer is required for Truck Head'));
    }
    return Promise.resolve();
  },
});

export const validationRule: Record<keyof TTripValidatedFormFields, FormRule[]> = {
  soldToPartners: [{ required: true, type: 'boolean' }],
  currency: [{ required: false, type: 'string' }],
  costPrice: [{ required: false, type: 'number' }],
  carrier: [{ required: true, type: 'object' }],
  contact: [{ required: true, type: 'object' }],
  truckId: [{ required: true, type: 'number' }],
  trailerId: [{ required: false, type: 'number' }],
  trailerPlate: [{ required: false, type: 'string' }],
};
